import { axiosIntance } from "./config"

export const getAllbooking = async()=>{
    const response = await axiosIntance.get('/books')
    return response.data
}


export const updatebooking = async (id,data) => {
  const response = await axiosIntance.put(`/books/${id}`,data); 
  return response.data;
};

export const createbooking = async (data) => {
  const response = await axiosIntance.post(`/books`, data); 
  return response.data;
};

export const getbooking = async(id)=>{
    const response = await axiosIntance.get(`/books/${id}`)
    return response.data
}

export const deletebooking = async(id)=>{
    const response = await axiosIntance.delete(`/books/${id}`)
    return response.data
}

/* export const getAllConfig = async()=>{
    const response = await axiosIntance.get('/events')
    return response.data
} */